module.exports = __webpack_public_path__ + "static/media/background14.8db55e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/background14.png
// module id = 54
// module chunks = 0